import { MeetingRequestViewState } from '../store/schema/MeetingRequestViewState';

export default function shouldShowResponseActions(viewState: MeetingRequestViewState): boolean {
    // Show the response editor if the user has not responded
    return !['Accept', 'Tentative', 'Decline'].includes(viewState.responseType);
}
